import { Store, ShieldCheck, Globe2, Users, Instagram, Facebook, Linkedin, MessageCircle, Package, ShoppingBag, Plane, Briefcase, Car, Building2, Network } from "lucide-react";

const services = (l) => {
  const es = l === "es";
  return [
    { id: "comercio", icon: Package, title: es ? "Comercio de mercancías" : "Goods trading", text: es ? "Compra y venta de mercancías conectando proveedores, empresas y clientes finales en distintos mercados." : "Buying and selling goods, connecting suppliers, businesses and end customers across markets." },
    { id: "ecommerce", icon: ShoppingBag, title: es ? "Ecosistema e-commerce" : "E-commerce ecosystem", text: es ? "Empresas y pequeños negocios pueden vender sus productos a través de nuestro ecosistema de comercio electrónico." : "Companies and small businesses can sell their products through our e-commerce ecosystem." },
    { id: "viajes", icon: Plane, title: es ? "Agencia de viajes" : "Travel agency", text: es ? "Organizamos tus viajes de negocios y de placer con atención personalizada." : "We organise your business and leisure trips with personalised service." },
    { id: "consultoria", icon: Briefcase, title: es ? "Consultoría empresarial" : "Business consulting", text: es ? "Acompañamos a empresas en su crecimiento, expansión y operación en el comercio global." : "We support companies in their growth, expansion and operations in global commerce." },
    { id: "renta", icon: Car, title: es ? "Renta de casas y autos" : "House & car rentals", text: es ? "Alquiler de viviendas y vehículos para estancias, viajes y necesidades de negocio." : "Rental of homes and vehicles for stays, trips and business needs." },
    { id: "realestate", icon: Building2, title: "Real estate", text: es ? "Servicios de bienes raíces: compra, venta e inversión en propiedades." : "Real estate services: buying, selling and investing in property." },
  ];
};
import { P2P_URL } from "@/lib/site";

// Editable content. Everything except the P2P link is sample copy.
export const SOCIALS = [
  { id: "instagram", label: "Instagram", icon: Instagram, href: "#" },
  { id: "facebook", label: "Facebook", icon: Facebook, href: "#" },
  { id: "linkedin", label: "LinkedIn", icon: Linkedin, href: "#" },
  { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: "#" },
];

const projects = (l) => [
  {
    id: "p2p",
    icon: Store,
    href: P2P_URL,
    name: l === "es" ? "Plataforma P2P" : "P2P Platform",
    desc: l === "es"
      ? "Compra/venta con inventario distribuido, entregas, mensajería y saldos."
      : "Buy and sell with distributed inventory, deliveries, messaging and balances.",
    status: l === "es" ? "Activo" : "Live",
    cta: l === "es" ? "Entrar" : "Enter",
    stats: [
      { value: "+12", label: l === "es" ? "Países" : "Countries" },
      { value: "24h", label: l === "es" ? "Liquidación" : "Settlement" },
      { value: "0%", label: l === "es" ? "Comisión VIP" : "VIP fee" },
    ],
  },
  {
    id: "viajes",
    icon: Plane,
    href: "#",
    name: l === "es" ? "Agencia de viajes" : "Travel agency",
    desc: l === "es" ? "Organizamos tus viajes de negocios y de placer con atención personalizada." : "We organise your business and leisure trips with personalised service.",
    status: l === "es" ? "Próximamente" : "Coming soon",
  },
];

export const content = {
  es: {
    nav: [{ id: "servicios", label: "Servicios" }, { id: "proyectos", label: "Proyectos" }, { id: "nosotros", label: "Nosotros" }, { id: "contacto", label: "Contacto" }],
    ctaP2P: "Ir a la Plataforma P2P",
    services: { kicker: "/ 01 — Servicios", title: "Todo lo que el comercio global necesita", sub: "Integramos diversas herramientas para acercar a los grandes negocios y empresas al cliente final de cada mercancía o servicio.", items: services("es") },
    hero: {
      eyebrow: "Hub oficial · Ecosistema Resilience Brothers",
      subtitle: "Soluciones integrales para el comercio global",
      body: "Integramos comercio, e-commerce, viajes, consultoría, rentas y real estate en un solo ecosistema para acercar a las empresas al cliente final.",
      primary: "Explorar proyectos",
      secondary: "Contáctanos",
      scroll: "Desliza",
      card: "Ecosistema",
    },
    marquee: ["Comercio global", "E-commerce", "Agencia de viajes", "Consultoría empresarial", "Renta de casas y autos", "Real estate"],
    projects: { kicker: "/ 02 — Proyectos", title: "Nuestros proyectos", sub: "Un solo hub para todo el ecosistema. Entra a lo que ya funciona y sigue lo que viene.", soon: "Próximamente", items: projects("es") },
    about: {
      kicker: "/ 03 — Nosotros",
      title: "Un puente entre las empresas y el cliente final.",
      body: "Resilience Brothers es una empresa de soluciones integrales para el comercio global. Reunimos en un mismo ecosistema herramientas de comercio, e-commerce y servicios para que grandes negocios y pequeñas empresas lleguen al cliente final de su mercancía o servicio.",
      pillars: [
        { icon: Network, title: "Ecosistema integrado", text: "Comercio, servicios y tecnología conectados en un solo lugar." },
        { icon: Globe2, title: "Alcance global", text: "Una red de socios estratégicos en múltiples mercados." },
        { icon: ShieldCheck, title: "Confianza", text: "Operaciones claras y verificadas en cada paso." },
        { icon: Users, title: "Trato cercano", text: "Un equipo real detrás de cada cliente y cada operación." },
      ],
    },
    contact: { kicker: "/ 04 — Contacto", title: "Hablemos.", sub: "¿Tienes una propuesta, una duda o quieres sumarte a un proyecto? Escríbenos.", socials: "Redes sociales", form: { title: "Escríbenos", name: "Nombre", email: "Tu email", message: "Tu mensaje", submit: "Enviar mensaje", sending: "Enviando…", sent: "¡Mensaje enviado! Te responderemos pronto.", error: "No se pudo enviar. Inténtalo de nuevo más tarde." } },
    footer: { links: "Enlaces rápidos", rights: "Todos los derechos reservados." },
  },
  en: {
    nav: [{ id: "servicios", label: "Services" }, { id: "proyectos", label: "Projects" }, { id: "nosotros", label: "About" }, { id: "contacto", label: "Contact" }],
    ctaP2P: "Go to P2P Platform",
    services: { kicker: "/ 01 — Services", title: "Everything global commerce needs", sub: "We integrate a range of tools to bring large businesses and companies closer to the end customer of every product or service.", items: services("en") },
    hero: {
      eyebrow: "Official hub · Resilience Brothers ecosystem",
      subtitle: "Integrated solutions for global commerce",
      body: "We bring trade, e-commerce, travel, consulting, rentals and real estate together in one ecosystem to connect businesses with the end customer.",
      primary: "Explore projects",
      secondary: "Contact us",
      scroll: "Scroll",
      card: "Ecosystem",
    },
    marquee: ["Global commerce", "E-commerce", "Travel agency", "Business consulting", "House & car rentals", "Real estate"],
    projects: { kicker: "/ 02 — Projects", title: "Our projects", sub: "One hub for the whole ecosystem. Jump into what's live and follow what's next.", soon: "Coming soon", items: projects("en") },
    about: {
      kicker: "/ 03 — About us",
      title: "A bridge between businesses and the end customer.",
      body: "Resilience Brothers is an integrated solutions company for global commerce. We bring trade, e-commerce and service tools together in one ecosystem so large businesses and small companies can reach the end customer of their products or services.",
      pillars: [
        { icon: Network, title: "Integrated ecosystem", text: "Trade, services and technology connected in one place." },
        { icon: Globe2, title: "Global reach", text: "A network of strategic partners across multiple markets." },
        { icon: ShieldCheck, title: "Trust", text: "Clear, verified operations at every step." },
        { icon: Users, title: "Human service", text: "A real team behind every client and every operation." },
      ],
    },
    contact: { kicker: "/ 04 — Contact", title: "Let's talk.", sub: "Have a proposal, a question or want to join a project? Write to us.", socials: "Social media", form: { title: "Write to us", name: "Name", email: "Your email", message: "Your message", submit: "Send message", sending: "Sending…", sent: "Message sent! We'll get back to you soon.", error: "Couldn't send. Please try again later." } },
    footer: { links: "Quick links", rights: "All rights reserved." },
  },
};
